import { render, staticRenderFns } from "./noticeManageList.vue?vue&type=template&id=ec0bfe06&scoped=true"
import script from "./noticeManageList.vue?vue&type=script&lang=js"
export * from "./noticeManageList.vue?vue&type=script&lang=js"
import style0 from "./noticeManageList.vue?vue&type=style&index=0&id=ec0bfe06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0bfe06",
  null
  
)

export default component.exports